import cn from '@integrations/classnames'
import { Fragment } from '@integrations/react'
import styles from './EmailText.module.scss'

interface Props {
  email?: string
  className?: string
}

// Stays on one line; when too long it wraps before "@domain", and a name part that is still too long breaks after
// "+", "." or "_" before it would break mid-word.
function EmailText({ email, className }: Props) {
  const at = email ? email.lastIndexOf('@') : -1
  if (!email || at < 1) {
    return <>{email}</>
  }
  const nameParts =
    email
      .slice(0, at)
      .match(/[^+._]*[+._]?/g)
      ?.filter(Boolean) ?? []
  return (
    <span className={cn(styles['email-text'], 'email-text', className)}>
      <span className={cn(styles['email-text-part'], 'email-text-part')}>
        {nameParts.map((part, index) => (
          <Fragment key={`${index}-${part}`}>
            {index > 0 && <wbr />}
            {part}
          </Fragment>
        ))}
      </span>
      <span className={cn(styles['email-text-part'], 'email-text-part')}>{email.slice(at)}</span>
    </span>
  )
}

export default EmailText
